<template>
  <b-card
    class="profile-header mb-2"
    header=" "
    :header-bg-variant="$route.path.includes('profile')?'primary':'info'"
    header-tag="header"
    header-class="py-5"
    body-class="p-0"
  >
    <profile-avator :user-data="userData" @updateUser="$emit('updateUser')" />
    <profile-navbar />
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import ProfileAvator from "./ProfileAvatar.vue";
import ProfileNavbar from "./ProfileNavbar.vue";

export default {
  components: {
    BCard,
    ProfileAvator,
    ProfileNavbar,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
